import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
  },
};

const slice = createSlice({
  name: 'historyLog',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET History Log
    getHistoryLogSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams } = slice.actions;

// ----------------------------------------------------------------------

export function getHistoryLog(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/history-log/', {
        params,
      });
      dispatch(slice.actions.getHistoryLogSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
